import script from "./OfflineWarning.vue?vue&type=script&setup=true&lang=js"
export * from "./OfflineWarning.vue?vue&type=script&setup=true&lang=js"

import "./OfflineWarning.vue?vue&type=style&index=0&id=dbf3e098&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbf3e098"]])

export default __exports__